import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GTMTracker = () => {
    const location = useLocation();

    useEffect(() => {
        // Ensure dataLayer exists
        window.dataLayer = window.dataLayer || [];

        // Push the page_view event
        // Note: You need to configure a custom event trigger in GTM for 'page_view'
        window.dataLayer.push({
            event: 'page_view',
            page_path: location.pathname + location.search,
            page_title: document.title
        });
    }, [location]);

    return null;
};

export default GTMTracker;
